import React, { useRef, useEffect } from 'react'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

const MapRouteComponent = ({ coordinates }) => {
  const mapRef = useRef(null)

  useEffect(() => {
    if (!coordinates || coordinates.length === 0) {
      return
    }

    const map = L.map(mapRef.current)
      .setView(coordinates[0], 5) // Center on the first coordinate

    // Add OpenStreetMap tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 20,
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map)

    // Draw the route using Polyline
    const polyline = L.polyline(coordinates, {
      color: 'blue',
      weight: 3,
      opacity: 0.75
    }).addTo(map)

    // Adjust the map to fit the polyline bounds
    map.fitBounds(polyline.getBounds())

    // Cleanup function to remove the map on component unmount
    return () => {
      map.remove()
    }
  }, [coordinates])

  return <div ref={mapRef} style={{ height: '200px', width: '100%' }} />
}

export default MapRouteComponent
